import gql from 'graphql-tag'

import { EntityFields } from '..'
import { MaintenanceBackupTypeFragment } from '@/graphql/fragments/public/maintenanceBackupType'
import { MaintenanceTypeFragment } from '.'
import { ProcessStatusFragment } from '@/graphql/fragments/settings'

export const MaintenanceBaseFragment = gql`
  fragment MaintenanceBase on maintenance{
    ${EntityFields}
    mileage
  }
`

export const MaintenanceFragment = gql`
  ${MaintenanceBaseFragment}
  ${MaintenanceTypeFragment}
  ${MaintenanceBackupTypeFragment}
  ${ProcessStatusFragment}
  fragment Maintenance on maintenance{
    ...MaintenanceBase
    type {
      ...MaintenanceType
    }
    status: process_status {
      ...ProcessStatus
    }
    backupType:backup_type {
      ...MaintenanceBackupType
    }
  }
`
